import { Business } from './Business';

type Entitlements = {
  canTriggerPrecisionAnalysis: boolean;
  canManageTransactions: boolean;
  canViewSurveys: boolean;
  canViewOwnedSurveyResponses: boolean;
  canViewSurveyResponsesOfTier1Suppliers: boolean;
  canMutateOwnedSurveyResponses: boolean;
  canDownloadSurveyResponses: boolean;
  canManageWebhooks: boolean;
  canAccessApi: boolean;
};

export type User = {
  firstName: string;
  lastName: string;
  email: string;
  completed: boolean;
  auth0UserId: string;
  business: Partial<Business>;
  businessId: string;
  locale: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  postCode?: string;
  country?: string;
  consentedAt?: Date;
  entitlements?: Partial<Entitlements>;
  createdAt: string;
};

export enum UserInvitationStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type UserInvitation = {
  id: string;
  email: string;
  status: UserInvitationStatus;
  sentByUser: Omit<User, 'business'> & { business: Business };
  createdAt: string;
  updatedAt: string;
};
